import React from 'react';

const PolitiqueConfidentialite = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="page-title">Politique de Confidentialité</h1>
        <div className="page-text">
          <p>Contenu à venir...</p>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
